// extracted by mini-css-extract-plugin
export default {"animate-btn-text":"animate-btn-text"};